export enum ModalEnum {
  MODAL_PREFIX = 'md#'
}
